import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import { Component, Prop, Watch } from 'vue-property-decorator';
import * as dateutil from '@appbase/util/date-helper';
import {
  CalendarEventDetail,
  CalendarEventResponseData,
  CalendarFolderInfo,
} from './types';
import { CURRENT } from '@account/store/types';
import EventListItem from './EventListItem.vue';
import { LoadingBar } from '@appbase/components/loading';
import NoData from '@webparts/components/common/NoData.vue';
import menuHelper from '@/modules/@appbase/util/menu-helper';
import * as types from '@webparts/store/types';
import { IEDate, uGetDateFormat } from '@appbase/util/date-helper';

export const COMMON_AUTO_COLOR_ARRAY = [
  '#ff4b09',
  '#ffc609',
  '#e0ff03',
  '#bdff09',
  '#29e1bf',
  '#0942ff',
  '#241eb4',
  '#c609ff',
  '#ff119a',
  '#c9dbdb',
];

@Component({
  components: { EventListItem, LoadingBar, NoData },
  computed: {
    ...mapGetters({
      current: CURRENT,
      folders: types.WEBPART_CALENDARFOLDER_DATA,
      dailyEvents: types.WEBPART_CALENDARDAILYEVENT_DATA,
    }),
  },

  methods: mapActions({
    loadEvents: types.WEBPART_CALENDARDAILYEVENT_DATA,
  }),
})
export default class EventList extends Vue {
  //
  // ────────────────────────────────────────────────── I ──────────
  //   :::::: P R O P S : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────
  //

  @Prop({ type: String }) value!: string;
  @Prop({ type: Array }) weeks!: string[];
  @Prop({ type: Boolean, default: false }) preview!: boolean;

  loadEvents!: (payload: { date: Date }) => Promise<graph.CalendarItem[]>;

  //
  // ──────────────────────────────────────────────── I ──────────
  //   :::::: D A T A : :  :   :    :     :        :          :
  // ──────────────────────────────────────────────────────────
  //

  current!: account.TCurrent;
  folders!: CalendarFolderInfo[];
  dailyEvents!: graph.CalendarItem[];

  events: Array<CalendarEventDetail> = Object.create(null);
  loading: boolean = true;
  text: string = this.$t('등록된_일정이_없습니다').toString();
  today: boolean = false;
  noMailBox: boolean = false;
  //
  // ──────────────────────────────────────────────────────── I ──────────
  //   :::::: C O M P U T E D : :  :   :    :     :        :          :
  // ──────────────────────────────────────────────────────────────────
  //

  get MonthDayDateFormat() {
    const szDate = uGetDateFormat('MM.DD', this.date);
    const szWeek = this.weeks[this.date.getDay()];
    return `${szDate} <span>${szWeek}</span>`;
  }

  get YearMonthDayDateFormat() {
    const szDate = uGetDateFormat('yyyy.MM.DD', this.date);
    const szWeek = this.weeks[this.date.getDay()];
    return `${szDate} (${szWeek})`;
  }

  get YearMonthDateFormat() {
    return uGetDateFormat('yyyy.MM', this.date);
  }

  get date(): Date {
    return IEDate(this.value);
  }

  //
  // ────────────────────────────────────────────────────── I ──────────
  //   :::::: W A T C H E S : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────────
  //

  @Watch('value')
  onValueChanged(newVal: string) {
    this.today = uGetDateFormat('yyyy-MM-DD', new Date()) == newVal;
    const date = IEDate(this.value);

    this.loading = true;
    this.loadEvents({ date: date });
  }

  @Watch('dailyEvents')
  onEventsChanged(newVal: graph.CalendarItem[]) {
    this.events = newVal.map<CalendarEventDetail>(e => ({
        scheduleId: e.id,
        isAllDay: e.isAllDay,
        title: e.subject,
        place: e.location.displayName,
        startDate: dateutil.IEDate(e.start.dateTime),
        endDate: dateutil.IEDate(e.end.dateTime),
        color: {
            category: '',
            hasColor: false,
            code: '',
        },
    }));

    this.loading = false;
  }

  created() {
    this.today = dateutil.uGetDateFormat('yyyy-MM-DD', new Date()) == this.value;
    this.onEventsChanged(this.dailyEvents);
  }

  handleSetToday = () => this.$emit('input', dateutil.uGetDateFormat('yyyy-MM-DD', new Date()));

  findColor(folderId: string) {
    return this.folders.find(f => f.id === folderId)?.color;
  }

  goToCalendar() {
    if (this.preview) return;
    window.open('https://outlook.office.com/calendar/view/month', '_blank');
  }
}
